import { createSelector } from "reselect";
import { getStoreCode } from "../regionalStore";

const getFeaturesStore = state => state.features;

const getMvt = createSelector(
  getFeaturesStore,
  feature => feature && feature.mvt
);

const getFeatures = createSelector(
  getFeaturesStore,
  feature => feature && feature.features
);

const getFlatFeaturesStore = state => ({
  ...getFeatures(state),
  ...getMvt(state)
});

export const getFeature = (state, key) => getFlatFeaturesStore(state)[key];

export const isFeatureActive = (state, key) => {
  const features = getFlatFeaturesStore(state);
  const feature = key in features ? features[key] : false;

  return feature;
};

export const isStoreSpecificFeatureActive = (state, key) => {
  const features = getFlatFeaturesStore(state);
  const feature = key in features ? features[key] : false;
  const storeCode = getStoreCode(state);
  return feature && feature[storeCode];
};

export const getFeaturesLoaded = createSelector(
  getFeaturesStore,
  feature => feature.loadComplete
);
